import React, { useState } from 'react';
import { Button, Checkbox, Form, Input } from 'antd';
import Axios from './utils/axios';



const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo);
};
const SignIn = ({}) => {
  const [errorMessage, setErrorMessage] = useState('');


  const onFinish = async (values) => {
    try {
      const response = await Axios.post('/signin', values)
      const responseData = await response.data;
      const status = response.status;
      if (status !== 200) {
        setErrorMessage(responseData.message);
        setTimeout(() => {
          setErrorMessage('');
        }, 5000);
      }else {
        window.location.reload();
      }
    }catch (err) {
      console.log(err);
    }
  };


  return (
    <div className='container mx-auto' style={{maxWidth: '700px', minHeight: '700px'}}>
      <div className='flex flex-col items-center justify-center' style={{minHeight: 'inherit'}}>
        <div className='bg-white p-3 shadow' style={{width: '60%',}}>
          <div className='flex justify-center'>
            <img src='https://www.casspian.com/uploads/caspian_logo.png' alt='caspian logo' width={200} />
          </div>
          <Form
            labelCol={{span: 6,}}
            labelAlign='left'
            initialValues={{ remember: true,}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"            
          >
            <Form.Item label="Email" name="email" className='font-semibold'
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please input your email!',
                },
              ]}
            >
              <Input className='font-normal'/>
            </Form.Item>

            <Form.Item label="Password" name="password" className='font-semibold'
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
              ]}
            >
              <Input.Password className='font-normal rounded-none' />
            </Form.Item>

            <Form.Item
              name="remember"
              valuePropName="checked"
              wrapperCol={{ offset: 6, }}
            >
              <Checkbox>Remember me</Checkbox>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, }} >
              <Button type="primary" htmlType="submit">
                Sign In
              </Button>
            </Form.Item>
            {errorMessage.length > 0 && <span className='text-red-500'>{errorMessage}</span>}
          </Form>
        </div>
      </div>
    </div>
  )
}
export default SignIn;